import { createBrowserHistory, BrowserHistory } from 'history'
import { useHistory as scrivitoUseHistory } from 'scrivito'
import { scrollToFragment } from 'scroll-to-fragment'

import { sanitizeSearch } from '@/utils/urlParamHygiene'

export function configureHistory(): void {
  const history = getHistory()
  if (!history) return

  // Strip junk query params (`?q=`, `?q=undefined`, bare `?q`) app-wide at the
  // single history choke-point: Scrivito never sanitizes, and every navigation —
  // including raw `navigateTo` callers — commits through this shared instance.
  // `replace` (not push) keeps the dirty URL out of the back-button history.
  sanitizeHistory(history)

  scrivitoUseHistory(history)

  scrollToFragment({ history })
}

function sanitizeHistory(history: BrowserHistory): void {
  const scrub = ({ search, pathname, hash }: BrowserHistory['location']) => {
    const cleaned = sanitizeSearch(search)
    if (cleaned !== null) {
      history.replace({ pathname, search: cleaned, hash })
    }
  }

  scrub(history.location)
  history.listen(({ location }) => scrub(location))
}

let currentHistory: BrowserHistory | undefined

/** @public */
export function getHistory(): BrowserHistory | undefined {
  if (typeof window === 'undefined') return

  if (!currentHistory) currentHistory = createBrowserHistory()
  return currentHistory
}
